<template>
  <div class="row" v-if="isActive">
    <div class="col m2 offset-m5">
      <div class="progress">
        <div class="indeterminate"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['is-active']
}
</script>

<style lang="scss">
@import '../../../theme';

.progress {
  background-color: lighten($theme-color, 25%) !important;

  .indeterminate {
    background-color: $theme-color !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Partial/Preloader.vue